var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { RadioButtonGroupStyles } from "./RadioButtonGroup.styles";
export var RadioButtonsGroup = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, options = _a.options, onChange = _a.onChange, getOptionSx = _a.getOptionSx, radioProps = _a.radioProps;
    var sx = RadioButtonGroupStyles();
    var handleChange = function (event) {
        onChange(event.target.value);
    };
    return (_jsxs(FormControl, { children: [_jsx(FormLabel, { id: "rentio-".concat(id, "-radio-buttons-group-label"), sx: sx.content.formLabel, children: label }), _jsx(RadioGroup, { "aria-labelledby": "rentio-".concat(id, "-radio-buttons-group-label"), name: "rentio-".concat(id, "-radio-buttons-group"), value: value, onChange: handleChange, sx: sx.content.radioGroup, children: options.map(function (option) {
                    var _a;
                    var selected = option.value === value;
                    var optionSx = (_a = getOptionSx === null || getOptionSx === void 0 ? void 0 : getOptionSx(selected)) !== null && _a !== void 0 ? _a : {};
                    return (_jsx(FormControlLabel, { sx: __spreadArray([
                            sx.content.formControlLabel(selected)
                        ], (Array.isArray(optionSx) ? optionSx : [optionSx]), true), value: option.value, control: _jsx(Radio, __assign({}, radioProps)), label: option.label, checked: selected }, option.value));
                }) })] }));
};
